import { render, staticRenderFns } from "./s-vr-one.vue?vue&type=template&id=5c312f8b&scoped=true&"
import script from "./s-vr-one.vue?vue&type=script&lang=js&"
export * from "./s-vr-one.vue?vue&type=script&lang=js&"
import style0 from "./s-vr-one.vue?vue&type=style&index=0&id=5c312f8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c312f8b",
  null
  
)

export default component.exports